/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useState} from "react";
import {withTranslation} from "react-i18next";

import {Grid} from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import {TextField, LinearProgress} from "@material-ui/core";

import DeleteIcon from "@material-ui/icons/Delete";

import {useMutation} from "@apollo/client";

import {useThemeData} from "../../../../context/ThemeDataContext";
import {useCartData} from "../../../../context/CartProvider";
import {useAuthData} from "../../../../context/AuthProvider";

import PhotoComponent from "../../../../components/Photo/PhotoComponent";
import GeneralButton from "../../../Buttons";

import {
    UPDATE_CARTPRODUCT,
    UPDATE_CARTPRODUCTS,
    DELETE_CARTPRODUCTS,
    GET_SHOPPINGCART,
} from "../../../../queries";


import {useQuery} from '@apollo/client';
import ProductPrice from "../../../ProductPrice";


function MiniCartProducts(props) {
    const {logins} = useAuthData();
    const {site_id} = useThemeData().themeData.site;
    const {
        primary_color_2,
        background_color_4,
    } = useThemeData().themeData.site.theme;
    const {
        loadingCart
    } =
        useCartData().cart;

    const setMessages = props.setMessages;

    const shippingMethod = localStorage.hasOwnProperty("shippingMethod")
        ? localStorage.getItem("shippingMethod")
        : '';

    const [linkClass] = useState({
        package: {id: "", product: ""},
        subproduct: {id: "", product: ""},
        single: {id: "", product: ""},
    });

    const [loadingId, setLoadingId] = useState();
    const [newCartProductId, setnewCartProductId] = useState();
    const [session_id] = useState(localStorage.getItem("session_id"));

    const {
        data: cartdata,
        loading: loadingcartdata,
        error: errorcartdata
    } =
        useQuery(GET_SHOPPINGCART, {
            variables: {
                session_id: session_id,
                site_id: site_id,
                login_name: [logins],
                shipping_method: shippingMethod
            },
            // fetchPolicy: "network-only",
            fetchPolicy: "cache-and-network",
            notifyOnNetworkStatusChange: true,
            onCompleted: (data) => {
                //console.log(data);
            },

            // skip: skipCartQuery,
        });

    const dataCart = cartdata;

    // function that converts string with comma to number with decimal
    function convertToNumber(value) {
        return +parseFloat(value.replace(",", ".")).toFixed(2);
    }

    function convertToComma(value) {
        return parseFloat(value).toFixed(2).toString().replace(".", ",");
    }

    function substractPrices(price1, price2) {
        return convertToComma(convertToNumber(price1) - convertToNumber(price2));
    }


    const onDeleted = () => {
        setMessages({
            deleteMessage: true,
            updateMessage: false,
            discountCodeMessage: false,
            discountCodeRemoved: false,
            discountCodeFailedMessage: false,
            discountCodeExistMessage: false,
            discountCodeUsedMessage: false,
            discountCodePriceMessage: false,
        });
    };

    const onUpdated = () => {
        // console.log('sfdadfdsfd')
        setMessages({
            updateMessage: true,
            deleteMessage: false,
            discountCodeMessage: false,
            discountCodeRemoved: false,
            discountCodeFailedMessage: false,
            discountCodeExistMessage: false,
            discountCodeUsedMessage: false,
            discountCodePriceMessage: false,
        });
    };


    async function UpdateProduct(e, product) {
        e.preventDefault();
        const value = e.target.value;
        const cart_id = await dataCart.shoppingcart.id;
        //console.log('kom ik hier')
        if (!loadingUpdateCartProduct) {
            const promise = new Promise((resolve, reject) => {
                setLoadingId(product.id);
                setnewCartProductId(product.product_id);
                resolve(
                    updateCartProduct({
                        variables: {
                            id: cart_id,
                            cart_rules_id: product.id,
                            product_id: product.product_id,
                            newId: value,
                        },
                        optimisticResponse: {
                            __typename: "Mutation",
                            updateCartProduct: {
                                __typename: "Shoppingcart",
                                id: cart_id,
                                cart_rules_id: product.id,
                                product_id: product.product_id,
                                newId: value,
                            },
                        },
                    })
                );
            });
            return promise.then(() => {
                // return refetchCart();
            });
        }
    }

    async function UpdateProductAmount(e, product) {
        e.preventDefault();
        //console.log('updateruu?')
        const value = e.target.value;
        if (value === 0) {
            HandleDeleteCartProducts(e, product.id);
            //console.log('value 0')
        } else {
            if (!loadingUpdateCart) {
                //console.log('promise?')
                setLoadingId(product.id);
                updateCartProducts({
                    variables: {
                        id: product.id,
                        amount: value,
                    },
                    optimisticResponse: {
                        __typename: "Mutation",
                        updateCartProducts: {
                            __typename: "Shoppingcart",
                            id: product.id,
                            amount: e.target.value,
                        }
                    },
                    update: (cache, {data}) => {
                        const {shoppingcart} = cache.readQuery({
                            query: GET_SHOPPINGCART,
                            variables: {
                                session_id: session_id,
                                site_id: site_id,
                                login_name: [logins],
                                shipping_method: shippingMethod
                            },
                        });

                        let subtotalPrice = 0.00;
                        let totalDiscount = 0.00;

                        //console.log(shoppingcart)


                        shoppingcart.cartproducts.forEach(product => {
                            subtotalPrice += convertToNumber(product.org_stuks_prijs) * convertToNumber(product.amount);
                            totalDiscount += convertToNumber(product.stuks_price) * convertToNumber(product.amount);
                        });

                        const totalPrice = subtotalPrice + convertToNumber(shoppingcart.shippingcost) + convertToNumber(shoppingcart.administrationcosts) - totalDiscount;


                        cache.writeQuery({
                            query: GET_SHOPPINGCART,
                            variables: {
                                session_id: session_id,
                                site_id: site_id,
                                login_name: [logins],
                                shipping_method: shippingMethod
                            },
                            data: {
                                shoppingcart: {
                                    __typename: "Shoppingcart",
                                    id: shoppingcart.id,
                                    subtotaal: convertToComma(subtotalPrice),
                                    totaal: totalPrice,
                                    tax: convertToComma(totalPrice * 21 / 121),

                                    shippingcost: shoppingcart.shippingcost,
                                    administrationcosts: shoppingcart.administrationcosts,
                                    cartproducts: shoppingcart.cartproducts.map((cartproduct) => {
                                        if (cartproduct.id === product.id) {
                                            return {
                                                ...cartproduct,
                                                amount: value,
                                                org_totaal_prijs: convertToComma(convertToNumber(cartproduct.org_stuks_prijs) * value),
                                                total_price: convertToComma(convertToNumber(cartproduct.stuks_price) * value),
                                            };
                                        } else {
                                            return cartproduct;
                                        }
                                    }),
                                },
                            },
                        });
                    },
                })
            }
        }
    }

    async function HandleDeleteCartProducts(e, product) {
        e.preventDefault();
        if (!loadingDeleteCartProducts) {
            deleteCartProducts({
                variables: {
                    id: product.id,
                },
                update: (cache, {data: {deleteCartProducts}}) => {
                    const {shoppingcart} = cache.readQuery({
                        query: GET_SHOPPINGCART,
                        variables: {
                            session_id: session_id,
                            site_id: site_id,
                            login_name: [logins],
                            shipping_method: shippingMethod
                        },
                    });
                    cache.writeQuery({
                        query: GET_SHOPPINGCART,
                        variables: {
                            session_id: session_id,
                            site_id: site_id,
                            login_name: [logins],
                            shipping_method: shippingMethod
                        },
                        data: {
                            shoppingcart: {
                                __typename: "Shoppingcart",
                                id: shoppingcart.id,
                                subtotaal: substractPrices(shoppingcart.subtotaal, product.total_price),
                                cartproducts: shoppingcart.cartproducts.filter(
                                    (cartproducts) => {
                                        return cartproducts.id !== product.id
                                    }
                                ),
                            },
                        },
                    });
                },
                optimisticResponse: {
                    __typename: "Mutation",
                    deleteCartProducts: {
                        __typename: "Shoppingcart",
                        id: product.id,
                        subtotaal: "0",
                        totaal: "0",
                        cartproducts: [],
                    },
                },
            })
        }
    }

    const [
        updateCartProduct,
        {loading: loadingUpdateCartProduct, error: errorUpdateCartProduct},
    ] = useMutation(UPDATE_CARTPRODUCT, {
        onCompleted: onUpdated,
        notifyOnNetworkStatusChange: true,
    });

    const [
        updateCartProducts,
        {loading: loadingUpdateCart, error: errorUpdateCart},
    ] = useMutation(UPDATE_CARTPRODUCTS, {
        onCompleted: onUpdated,
        notifyOnNetworkStatusChange: true,
    });

    const [
        deleteCartProducts,
        {
            loading: loadingDeleteCartProducts
        },
    ] = useMutation(DELETE_CARTPRODUCTS, {
        onCompleted: onDeleted,
        notifyOnNetworkStatusChange: true,

        // boosdoener?
        refetchQueries: [
            {
                query: GET_SHOPPINGCART,
                variables: {
                    session_id: session_id,
                    site_id: site_id,
                    login_name: [logins],
                    shipping_method: shippingMethod
                },
                // fetchPolicy: "network-only",
            },
        ],
    });


    if (loadingcartdata) return <p>{props.t("Loading...")}</p>;
    if (errorcartdata)
        return <p>{props.t("Looks like we have a problem...")}</p>;
    if (!cartdata) return null;

    return (
        <Card style={{
            overflowY: 'auto',
            maxHeight: '55vh'
        }}>
            {dataCart.shoppingcart.cartproducts !== null &&
            dataCart.shoppingcart.cartproducts.length !== 0
                ? dataCart.shoppingcart.cartproducts.map((cartproduct) => (
                    <div key={cartproduct.id}>
                        <CardContent
                            className="cartItems border-bottom-small padding-bottom-5px"
                            style={{borderColor: `${background_color_4}`}}
                        >
                            <Grid container direction="row" spacing={2}>
                                <Grid
                                    item
                                    xs={4}
                                    sm={4}
                                    md={4}
                                    lg={4}
                                    className="text-center-webkit"
                                >
                                    {cartproduct.products.product_type !==
                                    "pakket" ? (
                                        <>
                                            <PhotoComponent
                                                photo_id={cartproduct.photo_info.id}
                                                photo_file_name={
                                                    cartproduct.products.product_file
                                                }
                                                product_id={cartproduct.products.product_id}
                                                product_type={cartproduct.product_type}
                                                product_image={cartproduct.products.product_image}
                                                folder_id={cartproduct.photo_info.folder_id}
                                                combivel_id={cartproduct.combivel_id}
                                                site_id={site_id}
                                                product_color={cartproduct.image_effect}
                                                effect_file_name={
                                                    cartproduct.effect_file_name
                                                }
                                                effect_file_id={cartproduct.effect_file_id}
                                                effect_file_id_for={cartproduct.effect_file_id_for}
                                                photoType={1}
                                            />
                                        </>
                                    ) : (
                                        //pakket
                                        <>
                                            {cartproduct.subproducten
                                                .slice(0, 1)
                                                .map((productensub, i) => (
                                                    <React.Fragment key={i}>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            key={i}
                                                            className="padding-bottom-2"
                                                        >
                                                            <PhotoComponent
                                                                photo_id={
                                                                    productensub.photo_info.id
                                                                }
                                                                product_type={productensub.product_type}
                                                                product_image={productensub.products.product_image}
                                                                product_id={productensub.products.product_id}
                                                                photo_file_name={
                                                                    productensub.products.product_file
                                                                }
                                                                effect_file_name={
                                                                    cartproduct.effect_file_name
                                                                }
                                                                effect_file_id={
                                                                    cartproduct.effect_file_id
                                                                }

                                                                effect_file_id_for={
                                                                    cartproduct.effect_file_id_for
                                                                }

                                                                combivel_id={
                                                                    cartproduct.combivel_id
                                                                }
                                                                folder_id={
                                                                    productensub.photo_info.folder_id
                                                                }
                                                                product_color={
                                                                    productensub.image_effect
                                                                }
                                                                photoType={1}
                                                            />
                                                        </Grid>
                                                    </React.Fragment>
                                                ))}
                                        </>
                                    )}
                                </Grid>
                                <Grid
                                    item
                                    xs={8}
                                    sm={8}
                                    md={8}
                                    lg={8}
                                    className="text-start"
                                >
                                    <Grid container direction="row">
                                        {cartproduct.products.product_type !==
                                        "pakket" ? (
                                            <>
                                                <div className="font-bold">
                                                    <Typography
                                                        style={{color: `${primary_color_2}`}}
                                                        className={`${
                                                            linkClass.single.id ===
                                                            cartproduct.products.product_id
                                                                ? linkClass.single.product
                                                                : ""
                                                        }`}
                                                    >
                                                        {props.type === "equestrianPhotoService"
                                                            ? `${cartproduct.products.product_name}`
                                                            : `${cartproduct.products.product_type} ${cartproduct.products.product_name}`}
                                                    </Typography>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div
                                                    style={{color: `${primary_color_2}`}}
                                                    className={`font-bold ${
                                                        linkClass.single.id ===
                                                        cartproduct.products.product_id
                                                            ? linkClass.single.product
                                                            : ""
                                                    }`}
                                                >
                                                    {cartproduct.products.product_type}{" "}
                                                    {cartproduct.products.product_name}
                                                </div>
                                            </>
                                        )}
                                    </Grid>
                                    {cartproduct.products.product_type !== "pakket" &&
                                    cartproduct.image_effect !== "Normaal" ? (
                                        <Grid container direction="row">
                                            <Typography
                                                style={{color: `${primary_color_2}`}}
                                            >
                                                {props.t("shoppingcart:Effect")}:{" "}
                                                {cartproduct.image_effect}
                                            </Typography>
                                        </Grid>
                                    ) : null}
                                    {props.type === "equestrianPhotoService" &&
                                    (errorUpdateCartProduct ||
                                        loadingUpdateCartProduct ||
                                        loadingCart ||
                                        newCartProductId ===
                                        cartproduct.products.product_id) &&
                                    loadingId === cartproduct.id ? (
                                        <LinearProgress
                                            key={cartproduct.id}
                                            color="primary"
                                            className="align-self-center"
                                            style={{
                                                color: primary_color_2,
                                                width: "-webkit-fill-available",
                                            }}
                                        />
                                    ) : (
                                        props.type === "equestrianPhotoService" && (
                                            <TextField
                                                type="select"
                                                key={cartproduct.id}
                                                id={cartproduct.id}
                                                select
                                                SelectProps={{native: true}}
                                                label={props.t(
                                                    "shoppingcart:Change Product"
                                                )}
                                                value={cartproduct.products.product_id}
                                                onChange={(e) =>
                                                    UpdateProduct(e, cartproduct)
                                                }
                                                InputLabelProps={{shrink: true}}
                                                className="mb-2"
                                                variant="standard"
                                                fullWidth
                                            >
                                                {props.data.length !== 0 &&
                                                    props.data.find(
                                                        (f) =>
                                                            f.id === cartproduct.photo_info.id
                                                    ) !== undefined &&
                                                    props.data
                                                        .find(
                                                            (f) =>
                                                                f.id === cartproduct.photo_info.id
                                                        )
                                                        .folder.productlist.products.map(
                                                        (p) => {
                                                            return (
                                                                <option
                                                                    id={p.product_id}
                                                                    key={p.product_id}
                                                                    value={p.product_id}
                                                                >
                                                                    {p.productdetail.naam}
                                                                </option>
                                                            );
                                                        }
                                                    )}
                                            </TextField>
                                        )
                                    )}
                                    <Grid container direction="row">
                                        {props.type === "equestrianPhotoService" ? (
                                            (errorUpdateCart ||
                                                loadingUpdateCart ||
                                                cartproduct.amount === undefined) &&
                                            loadingId === cartproduct.id ? (
                                                <LinearProgress
                                                    key={cartproduct.id}
                                                    color="primary"
                                                    className="align-self-center"
                                                    style={{
                                                        color: primary_color_2,
                                                        width: "-webkit-fill-available",
                                                    }}
                                                />
                                            ) : cartproduct.products.product_type !==
                                            "download" &&
                                            props.product_type !==
                                            "groepsfoto download" ? (
                                                <TextField
                                                    type="select"
                                                    key={cartproduct.id}
                                                    id={cartproduct.id}
                                                    select
                                                    SelectProps={{native: true}}
                                                    label={props.t("shoppingcart:Quantity")}
                                                    value={cartproduct.amount}
                                                    onChange={(e) =>
                                                        UpdateProductAmount(e, cartproduct)
                                                    }
                                                    InputLabelProps={{shrink: true}}
                                                    className="mb-2"
                                                    variant="standard"
                                                    fullWidth
                                                >
                                                    {[...Array(10)].map((value, index) => {
                                                        return (
                                                            <option
                                                                id={index + 1}
                                                                key={index}
                                                                value={index}
                                                            >
                                                                {index}
                                                            </option>
                                                        );
                                                    })}
                                                </TextField>
                                            ) : (
                                                <p>1</p>
                                            )
                                        ) : (
                                            <div
                                                className="text-left"
                                                style={{color: `${primary_color_2}`}}
                                            >
                                                {props.t("shoppingcart:Quantity")}:{" "}
                                                {cartproduct.amount}
                                            </div>
                                        )}
                                    </Grid>
                                    <Grid container direction="row">
                                        <ProductPrice price={cartproduct.org_totaal_prijs}
                                                      actionprice={cartproduct.total_price} from={true}></ProductPrice>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {(props.navbar ||
                                props.type === "equestrianPhotoService") && (
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    className="margin-top-bottom-5px text-center-webkit"
                                >
                                    <GeneralButton
                                        key={session_id}
                                        className="btn width-fill"
                                        type="link"
                                        onClick={(e) =>
                                            HandleDeleteCartProducts(e, cartproduct)
                                        }
                                        disabled={loadingDeleteCartProducts}
                                        endIcon={<DeleteIcon color="inherit"/>}
                                    >
                                        {props.t("shoppingcart:Remove")}
                                    </GeneralButton>
                                </Grid>
                            )}
                        </CardContent>
                    </div>
                ))
                : null}
        </Card>
    );
}

export default React.memo(
    withTranslation(["message", "shoppingcart", "shoppage"])(MiniCartProducts)
);
